export const SOFTLINE_API_ROHSTOFFBEREITSTELLUNG_QUERY = '/v1/molkerei/rohstoffbereitstellung/query';
export const SOFTLINE_API_ROHSTOFFBEREITSTELLUNG_ARTIKEL = '/v1/milchmengenrechner/milchmengenrechner/firmamolkereiartstamm';
export const SOFTLINE_API_ROHSTOFFBILANZ_QUERY_DETAIL = '/v1/molkerei/rohstoffbereitstellung/detail'
export const SOFTLINE_API_ROHSTOFFBEREITSTELLUNG_FETTEINHEITENRECHNER = '/v1/molkerei/rohstoffbereitstellung/fetteinheitenrechner';

